import Repository from '@/repositories/marketing'
const resource = '/dynamic_contents'

export default {
  fetch(config){
    return Repository.get(`${resource}.json`,config)
  },
  getDetails(id, config){
    return Repository.get(`${resource}/${id}.json`,config)
  },
  create(config) {
    return Repository.post(`${resource}.json`,config)
  },
  update(id, payload, config) {
    return Repository.put(`${resource}/${id}.json`, payload, config)
  },
  delete (config) {
    return Repository.delete(`${resource}/bulk_delete.json`, config)
  },
  archiveRecord(id,config){
    return Repository.post(`${resource}/${id}/archive_record.json`, config)
  },
  structuredContentPreview(paylod, config){
    return Repository.post(`contents/structured_content_preview.json`,paylod, config)
  },
  checkRecordInUse(id,config){
    return Repository.get(`${resource}/${id}/check_modules_in_use.json`, config)
  },
}